interface CarouselItem {
  image: string;
  title: string;
  subtitle: string;
  desc: string;
  tag: string;
}

const carouselItems: CarouselItem[] = [
  {
    image: 'https://readdy.ai/api/search-image?query=Epic%20anime%20battle%20scene%20with%20swordsman%20facing%20giant%20demon%20under%20crimson%20moon%2C%20dramatic%20lighting%2C%20dynamic%20action%20composition%2C%20Japanese%20anime%20movie%20poster%20style%2C%20vivid%20red%20and%20dark%20tones%2C%20high%20quality%20illustration&width=1200&height=600&seq=91sakura-carousel-01&orientation=landscape',
    title: '鬼灭之刃专题',
    subtitle: '从柱训练到无限城，全面回顾',
    desc: '整理鬼灭之刃全系列观影顺序、角色解析及幕后花絮，助你完整体验这部现象级作品的魅力。',
    tag: '热门专题',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20landscape%20of%20a%20fantasy%20world%20with%20floating%20islands%20and%20magical%20creatures%2C%20golden%20sunset%20sky%2C%20adventurers%20walking%20on%20a%20path%2C%20studio%20ghibli%20inspired%20aesthetic%2C%20dreamy%20atmosphere&width=1200&height=600&seq=91sakura-carousel-02&orientation=landscape',
    title: '吉卜力作品全收录',
    subtitle: '宫崎骏经典动画回顾',
    desc: '从千与千寻到你想活出怎样的人生，吉卜力工作室全部作品高清收录，重温那些感动过我们的美好瞬间。',
    tag: '经典回顾',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Futuristic%20cyberpunk%20anime%20city%20with%20neon%20lights%20and%20flying%20vehicles%2C%20rainy%20night%20atmosphere%2C%20solo%20figure%20standing%20on%20rooftop%2C%20Japanese%20anime%20art%2C%20cinematic%20composition%2C%20high%20contrast%20lighting&width=1200&height=600&seq=91sakura-carousel-03&orientation=landscape',
    title: '科幻动漫大赏',
    subtitle: '攻壳、EVA到赛博朋克',
    desc: '科幻题材动漫作品专题合集，从经典老番到当季新作，探索未来世界的无限可能性。',
    tag: '题材精选',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Warm%20anime%20illustration%20of%20cherry%20blossom%20viewing%20party%20with%20friends%20under%20blooming%20trees%2C%20spring%20atmosphere%2C%20soft%20pink%20and%20warm%20light%2C%20Japanese%20anime%20style%2C%20peaceful%20and%20joyful%20scene&width=1200&height=600&seq=91sakura-carousel-04&orientation=landscape',
    title: '樱花季特别企划',
    subtitle: '春日追番指南',
    desc: '又是一年樱花季，91樱花精选了与樱花相关的动漫作品和场景混剪，陪你度过浪漫春日。',
    tag: '季节特辑',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Anime%20art%20of%20a%20mysterious%20detective%20office%20with%20clues%20and%20evidence%20boards%2C%20noir%20atmosphere%2C%20dim%20lighting%2C%20suspenseful%20mood%2C%20Japanese%20anime%20style%2C%20intricate%20details&width=1200&height=600&seq=91sakura-carousel-05&orientation=landscape',
    title: '悬疑推理剧场',
    subtitle: '烧脑番剧一次看够',
    desc: '从死亡笔记到夏日重现，精选高智商对决和反转不断的悬疑推理动漫，让你的大脑时刻保持高速运转。',
    tag: '类型专场',
  },
  {
    image: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20concert%20scene%20with%20idols%20performing%20on%20stage%2C%20glowing%20penlights%20in%20audience%2C%20energetic%20atmosphere%2C%20Japanese%20anime%20style%2C%20vibrant%20colors%2C%20music%20and%20dance%20theme&width=1200&height=600&seq=91sakura-carousel-06&orientation=landscape',
    title: '音乐番精选',
    subtitle: '让耳朵享受的动画',
    desc: '吹响吧上低音号、孤独摇滚、蓝色巨星……精选配乐出色、音画俱佳的音乐题材动漫作品合集。',
    tag: '主题合辑',
  },
];

export default function CarouselSection() {
  return (
    <section id="carousel" className="py-16 md:py-20 bg-background-50">
      <div className="max-w-6xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-950 mb-3">焦点专题</h2>
          <p className="text-sm text-foreground-500 max-w-xl mx-auto">91樱花编辑团队精心策划的动漫专题内容，深度探索你喜爱的作品</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5">
          {carouselItems.map((item, idx) => (
            <article key={idx} className="group bg-background-100 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-200 transition-all duration-300 flex flex-col">
              <div className="relative w-full h-44 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                  title={item.title}
                />
                <span className="absolute top-3 left-3 px-2.5 py-1 rounded-full bg-primary-500/90 text-background-50 text-xs font-medium whitespace-nowrap">
                  {item.tag}
                </span>
              </div>
              <div className="p-5 flex flex-col flex-1">
                <h3 className="font-heading text-base md:text-lg text-foreground-900 mb-1">{item.title}</h3>
                <p className="text-xs text-primary-600 font-medium mb-2">{item.subtitle}</p>
                <p className="text-sm text-foreground-500 leading-relaxed flex-1">{item.desc}</p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}